
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.727 2.906L13.937.633l.461-.43 3.07 2.977v.5l-3.07 2.976-.46-.43 1.789-2.28H2.14l1.789 2.28-.461.43L.399 3.68v-.5L3.468.203l.46.43-1.788 2.273h13.586z","fill":"currentColor"}})])
          )
        }
      }
    